/**
 * 购后回店：用 Custom Pixel 写入的邮箱，对店面 App Embed 的 window.clarity 做 identify。
 * 不加载 Clarity 脚本。没有 samduo_clarity_id 则不调用。
 */
(() => {
  const STORAGE_KEY = "samduo_clarity_id";

  function readPurchaseEmail() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function whenClarityReady(fn) {
    if (typeof window.clarity === "function") {
      fn();
      return;
    }

    const expiresAt = Date.now() + 10000;
    const schedule = window.requestIdleCallback
      ? (cb) => window.requestIdleCallback(cb, { timeout: 2000 })
      : (cb) => window.setTimeout(cb, 1);

    const tick = () => {
      if (typeof window.clarity === "function") {
        fn();
        return;
      }
      if (Date.now() >= expiresAt) return;
      schedule(tick);
    };

    schedule(tick);
  }

  function start() {
    const email = readPurchaseEmail();
    if (!email) return;
    whenClarityReady(() => window.clarity("identify", email));
  }

  if (typeof ConsentAppLoader !== "undefined") {
    ConsentAppLoader.whenConsented(start);
  } else {
    start();
  }
})();
